import React from "react";

const industriesData = [
  {
    title: "Restaurants & Cafés",
    items: [
      "Table management & KOT",
      "Customizable menus, combos & discounts",
      "Online ordering integrations",
      "Waste, staff & sales reports",
    ],
  },
  {
    title: "Retail Stores",
    items: [
      "Barcode scanning & label printing",
      "Multi-branch inventory & transfers",
      "Returns, exchanges & promotions",
      "Auto purchase orders",
    ],
  },
  {
    title: "Salons, Gyms & Services",
    items: [
      "Appointments & package billing",
      "Staff performance & commissions",
      "Memberships & subscriptions",
      "SMS/WhatsApp reminders",
    ],
  },
  {
    title: "Supermarkets & Chains",
    items: [
      "Franchise & multi-store control",
      "Central dashboards & reports",
      "Role-based access & approvals",
      "Accounting integrations",
    ],
  },
  {
    title: "Pharmacies & Clinics",
    items: [
      "Batch/expiry, S/N and compliance",
      "Substitutions & prescription flow",
      "Insurance & credit accounts",
      "Regulatory reports",
    ],
  },
  {
    title: "Hotels & Hospitality",
    items: [
      "F&B outlets, room posting",
      "Centralized rates & menus",
      "Multi-outlet consolidation",
      "Owner dashboards",
    ],
  },
];

const Industries = () => (
  <section id="industries" className="py-16 md:py-20 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-2xl md:text-3xl font-extrabold">Who Uses Armada POS?</h2>
      <p className="mt-2 text-slate-600 max-w-3xl">
        Armada POS adapts to the unique needs of restaurants, retailers, service providers, and chains — giving every business the tools to sell smarter.
      </p>

      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {industriesData.map((industry, idx) => (
          <div key={idx} className="rounded-2xl border bg-white p-6 shadow-sm hover:shadow transition">
            <h3 className="font-bold">{industry.title}</h3>
            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">
              {industry.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <p className="mt-8 text-slate-600 max-w-3xl">
        No matter your business, Armada POS scales with you.
      </p>
    </div>
  </section>
);

export default Industries;
